<!-- =========================================================================================
    File Name: ChatContact.vue
    Description: Chat contact - single component for chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div class="chat__contact flex items-center px-2 pt-4 pb-2" :class="{'bg-primary-gradient text-white shadow-lg': color(isActiveChatUser)}">
        <div class="contact__avatar mr-1">
            
            <vs-avatar class="border-2 border-solid border-white" :src="contact.profilephoto" size="42px" />
        </div>
        <div class="contact__container w-full flex items-center justify-between overflow-hidden">
            <div class="contact__info flex flex-col truncate w-5/6">
                <h5 class="font-semibold" :class="{'text-white': isActiveChatUser}">{{ contact.username }}</h5>
                <span class="truncate">{{ showLastMsg ? msg : contact.aboutt }}</span>
            </div>

            <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
                 <vs-icon v-if="ico_n === true" class="w-full" icon-pack="material-icons" size='25px' icon="reply" ></vs-icon>
                <span class="whitespace-no-wrap">{{ lastMessaged | date }}</span>
                <vs-chip class="number " v-show="unread !== 0" color="primary" v-if="ico_n === false ">{{ unread }}</vs-chip>
            </div>
        </div>
    </div>
</template>

<script>
import "firebase/firestore"
import * as firebase from 'firebase/app'
import "firebase/auth"
export default {
  props: {
    contact          : { type: Object,  required: true, },
    isActiveChatUser : { type: Boolean },
    newchat : { type: Boolean },
    lastMessaged     : { type: String,  default : "", },
    showLastMsg      : { type: Boolean, default: false },
    //unseenMsg        : { type: Number,  default : 0, }
  },
  data(){
      return{
          unread :0,
          msg:'',
          ico_n:false
      }
  },
  methods:{
      color(value){
          if (value) return true
          if(!value) return this.newchat
          else return false
      }
  },
 created(){
     
          this.unseenMsg
   
  },
  computed:{
      unseenMsg(){
          const user = firebase.auth().currentUser
          if(this.$acl.get[0]==='post' || this.$acl.get[0]==='hr'){
          //var seen = ''
          if(this.contact.role == 'student'){
          var messageRef = firebase.database().ref(this.contact.uid).child(user.uid);
          //console.log(this.contact.uid)
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                          var arr = data.val()
                        if(arr.msg){
                        this.msg = arr.msg.textContent
                         
                        //console.log(arr.msg.isSent)
                         if(arr.msg.role ==='editor'){
                              if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                                    //this.ico_n = false    
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                          
                       else if(arr.msg.role === 'post'){
                              //var lol = arr.msg.isSent
                             this.ico_n = true
                                }
                                else{
                                    this.ico_n = false
                                }
                          }
                   
                      })
          }
           else if(this.contact.role == 'support'){
         
                        this.msg = 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.'
                         
                          
                       
                             this.ico_n = false
                             this.unread++
                                
          }
          else if (this.contact.role == 'tpo'){
                      var Ref = firebase.database().ref(user.uid).child(this.contact.uid)
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                          var arr=data.val()
                        if(arr.msg){
                        this.msg = arr.msg.textContent
                        
                        //this.ico_n = arr.msg.isSent
                        //console.log(arr.msg.isSent)
                         if(arr.msg.role==='admin'){
                             //arr.msg.isSent=true
                             if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                           else if(arr.msg.role === 'editor'){
                              
                              //var lol = arr.msg.isSent
                              //console.log(" Here icon :", arr.msg.role)
                             this.ico_n = true
                               
                         }
                           }
                   
                      })
          }
           else if (this.contact.role == 'trp'){
                      var Ref = firebase.database().ref(user.uid).child(this.contact.uid)
                      Ref.orderByChild('timestamp').on('child_added' ,data => {
                          var arr=data.val()
                        if(arr.msg){
                        this.msg = arr.msg.textContent
                        
                        //this.ico_n = arr.msg.isSent
                        //console.log(arr.msg.isSent)
                         if(arr.msg.role==='trp'){
                             //arr.msg.isSent=true
                             if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                           else if(arr.msg.role === 'editor'){
                              
                              //var lol = arr.msg.isSent
                              //console.log(" Here icon :", arr.msg.role)
                             this.ico_n = true
                               
                         }
                           }
                   
                      })
          }
          }  
          if(this.$acl.get[0]==='editor'){
               if(this.contact.role == 'support'){
         
                        this.msg = 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.'
                         
                          
                       
                             this.ico_n = false
                             this.unread++
                                
          }
          //var seen = ''
          else{
          var messageRef = firebase.database().ref(user.uid).child(this.contact.uid);
          //console.log(this.contact.uid)
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                          var arr=data.val()
                        if(arr.msg){
                        this.msg = arr.msg.textContent
                        
                        //this.ico_n = arr.msg.isSent
                        //console.log(arr.msg.isSent)
                         if(arr.msg.role==='post'){
                             //arr.msg.isSent=true
                             if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                         else if(arr.msg.role==='admin'){
                             //arr.msg.isSent=true
                             if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                         else if(arr.msg.role==='trp'){
                             //arr.msg.isSent=true
                             if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                        else if(arr.msg.role === 'editor'){
                              
                              //var lol = arr.msg.isSent
                              //console.log(" Here icon :", arr.msg.role)
                             this.ico_n = true
                               
                         }
                           }
                   
                      })
          }
          }
           if(this.$acl.get[0]==='admin'){
                 if(this.contact.role == 'support'){
         
                        this.msg = 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.'
                         
                          
                       
                             this.ico_n = false
                             this.unread++
                                
          }
          //var seen = ''
          else{
          var messageRef = firebase.database().ref(this.contact.uid).child(user.uid);
          //console.log(this.contact.uid)
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                          var arr=data.val()
                          if(arr.msg){
                        this.msg = arr.msg.textContent
                          
                        //console.log(arr.msg.isSent)
                         if(arr.msg.role==='editor'){
                              if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                                    //this.ico_n = false    
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                       else if(arr.msg.role === 'admin'){
                              //var lol = arr.msg.isSent
                             this.ico_n = true
                                }
                                else{
                                    this.ico_n = false
                                }
                         
                   }
                      })
          }  
           }     
           if(this.$acl.get[0]==='trp'){
                 if(this.contact.role == 'support'){
         
                        this.msg = 'Welcome to Flairboat ! I am your Flairboat Chat Support. I am available 24*7 to help you.'
                         
                          
                       
                             this.ico_n = false
                             this.unread++
                                
          }
          //var seen = ''
          else{
          var messageRef = firebase.database().ref(this.contact.uid).child(user.uid);
          //console.log(this.contact.uid)
                      messageRef.orderByChild('timestamp').on('child_added' ,data => {
                          var arr=data.val()
                          if(arr.msg){
                        this.msg = arr.msg.textContent
                          
                        //console.log(arr.msg.isSent)
                         if(arr.msg.role==='editor'){
                              if(arr.msg.isSent){
                                 this.ico_n = false
                              if( !arr.msg.isSeen){     
                                  this.unread++
                                    //this.ico_n = false    
                              }
                               //console.log(" Here icon :", arr.msg.role, this.unread, this.ico_n)
                            }  
                         }
                       else if(arr.msg.role === 'trp'){
                              //var lol = arr.msg.isSent
                             this.ico_n = true
                                }
                                else{
                                    this.ico_n = false
                                }
                         
                   }
                      })
          }  
           }     
              
      }
  }
}
</script>

